module.exports = __webpack_public_path__ + "img/wutu.c0a449b8.png";